export default {
    FETCH_CURRENCIES_SUCCESS(state, payload) {
        state.currencies = payload.currencies;
        state.browsingCurrency = payload.currencies.filter((cr) => cr.iso == "USD")[0];
    },
}